import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';


function * createWorkspaceAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspaces', data.payload)
     yield put({type:'REQUEST_CREATE_WORKSPACE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * updateCreditsDistributionAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspace/credits_distribution', data.payload)
     yield put({type:'REQUEST_UPDATE_CREDITS_DISTRIBUTION_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspaces/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createWorkspaceLinkListenerAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspaceLinkListeners', data.payload)
     console.log(api.data, 'YOOOO');
       yield put({type:'REQUEST_CREATE_WORKSPACE_LINK_LISTENER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceLinkListenerAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspaceLinkListeners/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_LINK_LISTENER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createWorkspaceStringListenerAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspaceStringListeners', data.payload)
     yield put({type:'REQUEST_CREATE_WORKSPACE_STRING_LISTENER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceStringListenerAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspaceStringListeners/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_STRING_LISTENER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createWorkspaceListingWebsiteAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspaceListingWebsites', data.payload)
     console.log(api.data, 'YOOOO');
     if(api.data.error!=undefined){
       yield put({type:'REQUEST_SPECIFIC_ERROR', message:api.data.error})
     }else{
     yield put({type:'REQUEST_CREATE_WORKSPACE_LISTING_WEBSITE_SUCCESS', val:api.data});
  }}catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceListingWebsiteAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspaceListingWebsites/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_LISTING_WEBSITE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteWorkspaceListingWebsiteAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/workspaceListingWebsites/'+data.id)
     yield put({type:'REQUEST_DELETE_WORKSPACE_LISTING_WEBSITE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteWorkspaceLinkListenerAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/workspaceLinkListeners/'+data.id)
     yield put({type:'REQUEST_DELETE_WORKSPACE_LINK_LISTENER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteWorkspaceStringListenerAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/workspaceStringListeners/'+data.id)
     yield put({type:'REQUEST_DELETE_WORKSPACE_STRING_LISTENER_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * getCurrentWorkspaceAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/workspaces/'+data.id);
      try{if(api.data.error==true){localStorage.removeItem('current_workspace_id');}}catch(error){console.log(error, 'ERROR');}
      yield put({type:'REQUEST_ME_EXTRA', val:api.data});
      yield put({type:'REQUEST_GET_CURRENT_WORKSPACE_SUCCESS', val:api.data});
      yield put({type:'REQUEST_GET_CURRENT_WORKSPACE_SUCCESS_LAST_URL', val:api.data});
      yield put({type:'REQUEST_GET_ME'});
  }catch(error){console.log(error, 'ERROR');
    console.log('EROOOOOORRR', error);
    yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexWorkspaces(data){
  try{
    const api = yield call([axios, axios.get], '/api/workspaces')
    yield put({type:'REQUEST_INDEX_WORKSPACES_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_LOGOUT_SUCCESS'});
  }
}

function * updateWorkspaceDecisionsAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspace/decisions', data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_DECISIONS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceFieldsAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspace/fields', data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_FIELDS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceFieldAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspace/fields/'+data.id, data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_FIELD_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createWorkspaceFieldAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspace/fields', data.payload)
     yield put({type:'REQUEST_CREATE_WORKSPACE_FIELD_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateWorkspaceToggleSwitchAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspace/toggle_switch', data.payload)
     yield put({type:'REQUEST_UPDATE_WORKSPACE_TOGGLE_SWITCH_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteWorkspaceDecisionAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/workspace/decisions/'+data.id)
     yield put({type:'REQUEST_DELETE_WORKSPACE_DECISION_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteWorkspaceFieldAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/workspace/fields/'+data.id)
     yield put({type:'REQUEST_DELETE_WORKSPACE_FIELD_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * mergeWorkspaceDecisionsAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspace/decisions/merge/'+data.from+'/'+data.to)
     yield put({type:'REQUEST_MERGE_WORKSPACE_DECISIONS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * mergeWorkspaceFieldsAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/workspace/fields/merge/'+data.from+'/'+data.to)
     yield put({type:'REQUEST_MERGE_WORKSPACE_FIELDS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * updateWorkspaceSearchToolsAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/workspaceSearchTools', data.payload)
     yield put({type:'REQUEST_UPDATE_SEARCH_TOOLS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * createSmsLogin(data){
  try {
    const api = yield call([axios, axios.post], '/api/sms_logins', data.payload)
    yield put({ type: 'REQUEST_CREATE_SMS_LOGIN_SUCCESS', val: api.data });
  } catch (error) { console.log(error, 'ERROR'); yield put({ type: 'REQUEST_ERROR', val: error.response }) }
}

function * updateSmsLogin(data){
  try {
    const api = yield call([axios, axios.put], '/api/sms_logins/'+data.payload.id, data.payload)
    yield put({ type: 'REQUEST_UPDATE_SMS_LOGIN_SUCCESS', val: api.data });
  } catch (error) { console.log(error, 'ERROR'); yield put({ type: 'REQUEST_ERROR', val: error.response }) }
}

function * deleteSmsLogin(data){
  try {
    const api = yield call([axios, axios.delete], '/api/sms_logins/'+data.id)
    yield put({ type: 'REQUEST_DELETE_SMS_LOGIN_SUCCESS', val: api.data });
  } catch (error) { console.log(error, 'ERROR'); yield put({ type: 'REQUEST_ERROR', val: error.response }) }
}



function* Create_sms_login(){yield takeEvery('REQUEST_CREATE_SMS_LOGIN', createSmsLogin);}
function* Update_sms_login(){yield takeEvery('REQUEST_UPDATE_SMS_LOGIN', updateSmsLogin);}
function* Delete_sms_login(){yield takeEvery('REQUEST_DELETE_SMS_LOGIN', deleteSmsLogin);}



function* Create_workspace(){yield takeEvery('REQUEST_CREATE_WORKSPACE', createWorkspaceAsync);}
function* Update_workspace(){yield takeEvery('REQUEST_UPDATE_WORKSPACE', updateWorkspaceAsync);}
function* Create_workspace_link_listener(){yield takeEvery('REQUEST_CREATE_WORKSPACE_LINK_LISTENER', createWorkspaceLinkListenerAsync);}
function* Update_workspace_link_listener(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_LINK_LISTENER', updateWorkspaceLinkListenerAsync);}
function* Delete_workspace_link_listener(){yield takeEvery('REQUEST_DELETE_WORKSPACE_LINK_LISTENER', deleteWorkspaceLinkListenerAsync);}
function* Create_workspace_listing_website(){yield takeEvery('REQUEST_CREATE_WORKSPACE_LISTING_WEBSITE', createWorkspaceListingWebsiteAsync);}
function* Update_workspace_listing_website(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_LISTING_WEBSITE', updateWorkspaceListingWebsiteAsync);}
function* Delete_workspace_listing_website(){yield takeEvery('REQUEST_DELETE_WORKSPACE_LISTING_WEBSITE', deleteWorkspaceListingWebsiteAsync);}
function* Create_workspace_string_listener(){yield takeEvery('REQUEST_CREATE_WORKSPACE_STRING_LISTENER', createWorkspaceStringListenerAsync);}
function* Update_workspace_string_listener(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_STRING_LISTENER', updateWorkspaceStringListenerAsync);}
function* Delete_workspace_string_listener(){yield takeEvery('REQUEST_DELETE_WORKSPACE_STRING_LISTENER', deleteWorkspaceStringListenerAsync);}
function* Get_current_workspace(){yield takeEvery('REQUEST_GET_CURRENT_WORKSPACE', getCurrentWorkspaceAsync);}
function* Index_workspaces(){yield takeEvery('REQUEST_INDEX_WORKSPACES', indexWorkspaces);}

function* Update_workspace_credit_distribution(){yield takeEvery('REQUEST_UPDATE_CREDITS_DISTRIBUTION', updateCreditsDistributionAsync);}
function* Update_workspace_toggle_switch(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_TOGGLE_SWITCH', updateWorkspaceToggleSwitchAsync);}

function* Update_workspace_decisions(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_DECISIONS', updateWorkspaceDecisionsAsync);}
function* Update_workspace_fields(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_FIELDS', updateWorkspaceFieldsAsync);}
function* Update_workspace_field(){yield takeEvery('REQUEST_UPDATE_WORKSPACE_FIELD', updateWorkspaceFieldAsync);}
function* Create_workspace_field(){yield takeEvery('REQUEST_CREATE_WORKSPACE_FIELD', createWorkspaceFieldAsync);}
function* Delete_workspace_decision(){yield takeEvery('REQUEST_DELETE_WORKSPACE_DECISION', deleteWorkspaceDecisionAsync);}
function* Delete_workspace_field(){yield takeEvery('REQUEST_DELETE_WORKSPACE_FIELD', deleteWorkspaceFieldAsync);}
function* Merge_workspace_decisions(){yield takeEvery('REQUEST_MERGE_WORKSPACE_DECISIONS', mergeWorkspaceDecisionsAsync);}
function* Merge_workspace_fields(){yield takeEvery('REQUEST_MERGE_WORKSPACE_FIELDS', mergeWorkspaceFieldsAsync);}

function* Update_workspace_search_tools(){yield takeEvery('REQUEST_UPDATE_SEARCH_TOOLS', updateWorkspaceSearchToolsAsync);}

export default function* Root_lists(){
  yield all([
    fork(Get_current_workspace),
    fork(Index_workspaces),
    fork(Create_workspace),
    fork(Update_workspace),
    fork(Update_workspace_toggle_switch),
    fork(Create_workspace_listing_website),
    fork(Update_workspace_listing_website),
    fork(Delete_workspace_listing_website),
    fork(Create_workspace_link_listener),
    fork(Update_workspace_link_listener),
    fork(Delete_workspace_link_listener),
    fork(Create_workspace_string_listener),
    fork(Update_workspace_string_listener),
    fork(Delete_workspace_string_listener),
    fork(Update_workspace_credit_distribution),
    fork(Update_workspace_decisions),
    fork(Update_workspace_fields),
    fork(Update_workspace_field),
    fork(Create_workspace_field),
    fork(Delete_workspace_decision),
    fork(Delete_workspace_field),
    fork(Merge_workspace_decisions),
    fork(Merge_workspace_fields),
    fork(Update_workspace_search_tools),

    fork(Create_sms_login),
    fork(Update_sms_login),
    fork(Delete_sms_login)
  ])}
